export const equipmentConsumptionHistoryColumns = [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'type' },
  { label: 'Status', value: 'status' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Vlr. Total', value: 'total_amount' },
  { label: 'Tarifas', value: 'fee_total' },
  { label: 'Ret. IR.', value: 'income_tax_total_amount' },
  { label: 'Filial', value: 'branch' },
  { label: 'Cartão', value: 'card' },
  { label: 'Un/Consumo Informado', value: 'current_equipment_usage' },
  { label: 'Placa do veículo', value: 'equipment_license_plate' },
  { label: 'Autor', value: 'author' },
  { label: 'Data e hora', value: 'created_at' },
]
